import { render, staticRenderFns } from "./CardOtherIcon.vue?vue&type=template&id=41c810c2&scoped=true&"
import script from "./CardOtherIcon.vue?vue&type=script&lang=js&"
export * from "./CardOtherIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardOtherIcon.vue?vue&type=style&index=0&id=41c810c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c810c2",
  null
  
)

export default component.exports